export default {
	players: [
		{
			name: 'FEDE',
			turn: true,
			alignment: { friend: '1', foe: '0' },
			revealed: { friend: false, foe: false },
			allowedToAccuse: { friend: true, foe: true },
		},
		{
			name: 'SARA',
			turn: false,
			alignment: { friend: '0', foe: '3' },
			revealed: { friend: false, foe: false },
			allowedToAccuse: { friend: true, foe: true },
		},
	],
	hasTurnEnded: false,
	pieces: [
		{
			id: '0-A1',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-A2',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-A3',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-A4',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-A5',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-C',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-S',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-N',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-A1',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-A2',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-A3',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-A4',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-A5',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-C',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-S',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-N',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-A1',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-A2',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-A3',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-A4',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-A5',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-C',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-S',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-N',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-A1',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-A2',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-A3',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-A4',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-A5',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-C',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-S',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-N',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
	],
	pieceState: 'deselection',
	followMouse: false,
	snipe: false,
	snipeWindow: null,
	piecesPrevState: [
		{
			id: '0-A1',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-A2',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-A3',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-A4',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-A5',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-C',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-S',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '0-N',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-A1',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-A2',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-A3',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-A4',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-A5',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-C',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-S',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '1-N',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-A1',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-A2',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-A3',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-A4',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-A5',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-C',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-S',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '2-N',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-A1',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-A2',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-A3',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-A4',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-A5',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-C',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-S',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
		{
			id: '3-N',
			selected: false,
			killed: false,
			showMoveCells: false,
			throughSniperLineOf: [],
			buffed: false,
			highlight: false,
		},
	],
	teamControl: [
		{ player: null, prevPlayer: null, claimEnabled: true, controlling: false },
		{ player: null, prevPlayer: null, claimEnabled: true, controlling: false },
		{ player: null, prevPlayer: null, claimEnabled: true, controlling: false },
		{ player: null, prevPlayer: null, claimEnabled: true, controlling: false },
	],
};
